import {
  Accordion as MuiAccordion,
  AccordionSummary,
  AccordionDetails,
  Typography,
  Box,
} from '@mui/material';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import React, { FC, ReactElement } from 'react';
import { useStyles } from './Accordion.styles';

interface AccordionProps {
  expanded: boolean;
  title?: string;
  description?: ReactElement | string;
  padding?: number;
  minHeight?: number;
  contentTopPadding?: number;
  hover?: boolean;
  onChange: () => void;
  dataTestId?: string;
}

export const Accordion: FC<AccordionProps> = ({
  expanded,
  description,
  title,
  padding = 3,
  minHeight = 3,
  contentTopPadding = 3,
  hover = true,
  onChange,
  dataTestId,
  children,
}) => {
  const { classes } = useStyles({ padding, hover, contentTopPadding, minHeight });

  return (
    <MuiAccordion
      className={classes.root}
      expanded={expanded}
      onChange={() => onChange()}
      data-testid={dataTestId}
    >
      <AccordionSummary expandIcon={<ExpandMoreIcon />}>
        <Box className={classes.accordionSummary}>
          <Typography className={classes.accordionTitle}>{title}</Typography>
          <Box className={classes.descriptionContainer}>{description}</Box>
        </Box>
      </AccordionSummary>
      <AccordionDetails>{children}</AccordionDetails>
    </MuiAccordion>
  );
};
